/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Constructor_UserInputs */

const es_co2_error_constructor_user = /** @type {(inputs: Error_Constructor_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este usuario pertenece a una empresa constructora y no puede unirse a una empresa aseguradora.`)
};

/**

* @param {Error_Constructor_UserInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_constructor_user = /** @type {((inputs?: Error_Constructor_UserInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Constructor_UserInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_constructor_user(inputs)
});